export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_Dario_ACCESO.a7c8dde5.jpg";